module.exports = __webpack_public_path__ + "img/icon_map_huanjingjiankong_lixian_dianji.4a48661a.svg";